<template>
    <div v-if="$store.state.currentClient">
        <BasicHeader pretitle="Client Dashboard"
            :title="`${$store.state.currentClient.name} <code class='badge bg-secondary'>${$store.state.currentClient.cid}</code>`"
            :sideTitle="`Welcome, ${$store.state.currentUser.name}!`" />

        <div class="container-fluid">
            <div class="row">
                <div class="col-md-8">

                    <div class="row">
                        <!-- Marketplace Error Display -->
                        <div v-if="isMarketplaceClient && marketplaceProductsError" class="col-12 mb-3">
                            <div class="alert alert-warning" role="alert">
                                <strong>Marketplace Error:</strong> {{ marketplaceProductsError }}
                            </div>
                        </div>

                        <div v-if="hasAUT" class="col-6">
                            <div class="card" style="cursor: pointer;" @click="navigateToCheckList">
                                <div class="card-body">
                                    <div class="row align-items-center">
                                        <div class="col-auto">
                                            <i class="fa fa-tag display-4"></i>
                                        </div>
                                        <div class="col ms-n2">
                                            <h4 class="mb-1">
                                                aUT
                                            </h4>
                                            <p class="small text-muted mb-0">
                                                <time datetime="2018-06-21">aqfer Universal Tag</time>
                                            </p>
                                        </div>
                                        <div class="col-auto">
                                            <p class="card-text">
                                                <span v-if="getProductStatus('aUT') === 'enabled'">
                                                    <span class="text-success">●</span> Enabled
                                                </span>
                                                <span v-else-if="getProductStatus('aUT') === 'loading'">
                                                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                    Loading...
                                                </span>
                                                <span v-else-if="getProductStatus('aUT') === 'pending'">
                                                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                    In Progress
                                                </span>
                                                <span v-else>
                                                    <span class="text-danger">●</span> Disabled
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                    <!-- Steps completion indicator -->
                                    <div v-if="tagManagerChecklistSteps" class="steps-indicator position-absolute bottom-0 end-0 m-2">
                                        <span :class="['badge steps-badge',aUTCompletionSteps==8?'bg-sucess':'bg-primary']">{{ completedStepsText }} Steps</span>
                                    </div>
                                </div> 
                            </div>
                        </div>

                        <div v-if="hasAMDP" class="col-6">
                            <div class="card pe-none">
                                <div class="card-body">
                                    <div class="row align-items-center">
                                        <div class="col-auto">
                                            <i class="fa fa-database display-4"></i>
                                        </div>
                                        <div class="col ms-n2">
                                            <h4 class="mb-1">
                                                aMDP
                                            </h4>
                                            <p class="small text-muted mb-0">
                                                <time datetime="2018-06-21">aqfer Marketing Data Platform</time>
                                            </p>
                                        </div>
                                        <div class="col-auto">
                                            <p class="card-text">
                                                <span v-if="getProductStatus('aMDP') === 'enabled'">
                                                    <span class="text-success">●</span> Enabled
                                                </span>
                                                <span v-else-if="getProductStatus('aMDP') === 'loading'">
                                                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                    Loading...
                                                </span>
                                                <span v-else-if="getProductStatus('aMDP') === 'pending'">
                                                    <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                                    Pending
                                                </span>
                                                <span v-else>
                                                    <span class="text-danger">●</span> Disabled
                                                </span>
                                            </p>
                                        </div>
                                    </div> 
                                </div> 
                            </div>
                        </div>
                    </div>

                    <!-- Tag Chart -->
                    <div class="row" v-if="hasAUT"> 
                       <div class="col-12" v-if="$store.getters.userRoles.isAccessByRole([1, 1.5]) && onBoardStatusList.length">
                            <div class="card">
                                <div class="card-header d-flex justify-content-between align-items-center">
                                    <span class="card-header-title">
                                         <strong>Onboarding Status</strong>
                                       </span>
                                    <button class="btn btn-sm btn-outline-secondary" @click="onRefresh" type="button">
                                        <i class="fa fa-refresh" aria-hidden="true"></i>
                                    </button>   
                                    </div>
                                <div class="card-body">
                                    <div v-if="onBoardStatusList.length === 0" class="text-center py-3">
                                        <div class="spinner-border text-primary" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                        <p class="mt-2 text-muted mb-0">Loading onboarding status...</p>
                                    </div>
                                    <div v-else>
                                        <div v-for="(item, index) in filteredOnBoardStatusList" :key="index">
                                            <div class="row align-items-center py-2">
                                                <div class="col-auto">
                                                    <i class="fa fa-cube display-6"></i>
                                                </div>
                                                <div class="col">
                                                    <h5 class="mb-2 fw-bold">{{ item.sku }}</h5>
                                                    <div class="small">
                                                        <div v-for="(stage, stageIndex) in item.stages" :key="stageIndex" class="d-flex justify-content-between align-items-center mb-1">
                                                            <span>
                                                                {{ stage.stage }}: 
                                                                <span v-if="stage.status === 'COMPLETED'" class="text-success">●</span>
                                                                <span v-else-if="stage.status === 'IN_PROGRESS'" class="text-warning">●</span>
                                                                <span v-else-if="stage.status === 'FAILED'" class="text-danger">●</span>
                                                                <span v-else class="text-primary">●</span>
                                                                {{ formatStatusText(stage.status) }}
                                                            </span>
                                                            <span class="text-muted">
                                                                <time>{{ DateTimeFormat(stage.last_updated_at) }}</time>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <hr v-if="index < filteredOnBoardStatusList.length - 1" class="my-2">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <span class="card-header-title">
                                         <strong>Overall Hourly Tag Counts (UTC)</strong>
                                        <router-link class="small ms-1" :to="`/${cid}/aut/dashboards`">View More</router-link>
                                    </span>                                    
                                    
                                    <span class="text-secondary me-3">
                                        Display Current Hour:
                                    </span>
                                    <div class="custom-control form-switch">
                                        <input type="checkbox" class="form-check-input" id="customSwitch1" v-model="showCurrentHour">
                                    </div>
                                </div>
                                <div class="card-body">
                                    <div v-if="errMsg">
                                        <p>{{errMsg}}</p>
                                    </div>                                   
                                    <!-- Chart -->
                                    <div v-if="!graphLoading" class="chart-view" >
                                        <canvas  id="countChart" 
                                                class="chart-canvas"
                                                width="843"
                                                height="300"
                                                style="
                                                    display: block;
                                                    box-sizing: border-box;
                                                    height: 300px;
                                                    width: 843px;
                                                "
                                        >
                                        </canvas>
                                    </div>
                                    <div v-else class="text-center">
                                        <div class="spinner-border" role="status">
                                            <span class="visually-hidden">Loading...</span>
                                        </div>
                                    </div>      
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="col-md-4">
                    <div v-if="recentPages.length" class="card card-sm">
                        <div class="card-header py-1">
                            <h4 class="card-header-title small mb-0">Recently Visited</h4>
                        </div>
                        <div class="card-body py-2">
                            <div class="list-group list-group-flush list-group-sm">
                                <router-link v-for="page in recentPages" :key="page.path"
                                    :to="page.path"
                                    class="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-2 px-0 border-0 recent-page-link">
                                    <span class="small text-truncate me-2">{{ page.name }}</span>
                                    <small class="text-muted text-nowrap" style="font-size: 0.7rem;">{{ formatTimeAgo(page.timestamp) }}</small>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-header">
                            <h4 class="card-header-title">Insights Blog</h4>
                            <a href="https://aqfer.com/blog/" target="_blank" class="small">View All</a>
                        </div>
                        <div class="card-body"> 
                            <div v-if="!blogLoading">
                                <BlogList :blogList="blogList.slice(0, 3)"/>
                            </div>
                            <div v-else class="text-center">
                                <div class="spinner-border" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div> 
                        </div>
                    </div>
                    <!-- hiding the changelog -->
                    <div v-if="false" class="card">
                        <div class="card-header">
                            <h4 class="card-header-title">Recent Changelog</h4>
                            <router-link class="small" to="/changelog">View More</router-link>
                        </div>
                        <div class="card-body">
                            <ChangeLogList :logList="logList.slice(0,3)"/>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div v-else class="no-clients">
        <div class="no-clients__card">
            <img
                :src="require($store.state.darkMode ? '../assets/logo.png' : '../assets/logo2.png')"
                alt="aqfer"
                class="no-clients__logo" />
            <h1 class="no-clients__title">Welcome!</h1>
            <p class="no-clients__lead">
                We couldn't find any clients for <b>{{ $store.state.currentUser.email }}</b>.
            </p>
            <p class="no-clients__text">
                Take a look at our
                <a href="https://help.aqfer.net" target="_blank" rel="noopener">documentation</a>
                to learn how to get started, or reach out to your account team to request access.
            </p>
            <div class="no-clients__actions">
                <a href="https://help.aqfer.net" target="_blank" rel="noopener" class="btn btn-primary">
                    <i class="fa-solid fa-book-open me-2"></i>View documentation
                </a>
                <a href="mailto:support@aqfer.com?Subject=CX Portal Access" class="btn btn-outline-secondary">
                    <i class="fa-solid fa-envelope me-2"></i>Contact support
                </a>
            </div>
            <router-link to="/logout" class="no-clients__logout">
                <i class="fa-solid fa-arrow-right-from-bracket me-1"></i>Log out
            </router-link>
        </div>
    </div>
</template>

<script>

import {
  Chart,
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
  SubTitle
} from 'chart.js';

Chart.register(
  ArcElement,
  LineElement,
  BarElement,
  PointElement,
  BarController,
  BubbleController,
  DoughnutController,
  LineController,
  PieController,
  PolarAreaController,
  RadarController,
  ScatterController,
  CategoryScale,
  LinearScale,
  LogarithmicScale,
  RadialLinearScale,
  TimeScale,
  TimeSeriesScale,
  Decimation,
  Filler,
  Legend,
  Title,
  Tooltip,
  SubTitle
);


import BasicHeader from "../components/BasicHeader.vue";
import ChangeLogList from "../components/ChangeLogList.vue";
import BlogList from "../components/BlogList.vue";
import dayjs from "dayjs";
import axios from 'axios';
import {mapState} from "vuex";
import data from "../../changelog.yaml"
import { sortKeysRecursively, getCountsData, generateHourAndRawMetricsTimeRanges } from "../utils/counts";
import { DateTimeFormat } from "../utils/commonFunction"
export default {
    components: { BasicHeader,ChangeLogList,BlogList },
    name: "Dashboard",
    data() {
        return {
            graphLoading: true,
            errMsg: null,
            logList:data.changelog,
            blogList:[],
            blogLoading: true,
            showCurrentHour: false,
            marketplaceProducts: [],
            marketplaceProductsLoading: false,
            marketplaceProductsError: null,
            onBoardStatusList:[],
            skuList: [],
            checkListStatus: null,
            recentPages: []
        }

    },
    computed: {
     ...mapState({
            cid: state => state.currentClient ? state.currentClient.cid : null,
        }),
        thisDay() {
            return dayjs().format('YYYYMMDD');    
        },
        previousDay() {
             return dayjs().subtract(1, "day").format('YYYYMMDD');
        },
        lastweek_thisday() {
            return dayjs().subtract(7, "day").format('YYYYMMDD');
        },
        isMarketplaceClient() {
            return this.$store.state.currentClient?.is_mkt_client === true;
        },
        marketplaceAccountId() {
            return this.$store.state.currentClient?.account_id;
        },
        hasAUT() {
            if (this.isMarketplaceClient) {
                return this.marketplaceProducts.some(product => 
                    product.product === 'aUTTest2' || product.product === 'aUT' || product.product.includes('aUT')
                );
            }
            let features = this.$store.state.currentClient.config.features;
            if (features.some(e => e.name === 'TAG_MANAGER')) {
                return true
            }
            return false
        },
        hasAMDP() {
            if (this.isMarketplaceClient) {
                return this.marketplaceProducts.some(product => 
                    product.product === 'aMDP' || product.product.includes('aMDP')
                );
            }
            let features = this.$store.state.currentClient.config.features;
            if (features.some(e => e.name === 'DATA_LAKE')) {
                return true
            }
            return false;
        },
        tagManagerChecklistSteps() {
            if (this.checkListStatus && this.checkListStatus.config && this.checkListStatus.config.features) {
                const tagManagerFeature = this.checkListStatus.config.features.find(
                    feature => feature.name === "TAG_MANAGER"
                );
                return tagManagerFeature?.checklist_steps ? tagManagerFeature.checklist_steps : null;
            }
            return null;
        },
        completedStepsText() {
            if(this.tagManagerChecklistSteps){
                const completedSteps = Object.values(this.tagManagerChecklistSteps).filter(status => status).length;
                return `${completedSteps}/8`;
            }
            return ''
        },
        aUTCompletionSteps() {
            if(this.tagManagerChecklistSteps){
                const completedSteps = Object.values(this.tagManagerChecklistSteps).filter(status => status).length;
                return completedSteps
            }
            return ''
        },
        getProductStatus() {
            return (productName) => {
                if (this.isMarketplaceClient) {
                    if (this.marketplaceProductsLoading) {
                        return 'loading';
                    }
                    const product = this.marketplaceProducts.find(p => 
                        p.product === productName || p.product.includes(productName)
                    );
                    if (product) {
                        return product.status === 'COMPLETED' ? 'enabled' : 'pending';
                    }
                    return 'disabled';
                }
                return this.$store.state.aut.autClientData?.enabled ? 'enabled' : 'disabled';
            };
        },
        isEnabled() {
            if (this.isMarketplaceClient) {
                return this.getProductStatus('aUT') === 'enabled';
            }
            return this.$store.state.aut.autClientData?.enabled;
        },
        filteredOnBoardStatusList() {
            if (!this.skuList || this.skuList.length === 0) {
                return [];
            }
            const activeSkus = this.skuList.filter(sku => sku.status !== 'COMPLETED').map(sku => sku.sku);
            return this.onBoardStatusList.filter(item => 
                activeSkus.includes(item.sku)
            );
        },
    },
    watch: {
        showCurrentHour() {
            this.startDrawHourlyGraph('countChart',this.tempObjT, this.tempObjY, this.tempObjLWT );
        },
        '$store.state.currentClient'(newClient, oldClient) {
            if (newClient && newClient !== oldClient) {
                // Reset marketplace data when client changes
                this.marketplaceProducts = [];
                this.marketplaceProductsLoading = false;
                this.marketplaceProductsError = null;
                
                // Fetch marketplace products if this is a marketplace client
                if (this.isMarketplaceClient) {
                    this.fetchMarketplaceProducts();
                }
            }
        },
    },
    methods: {
        DateTimeFormat,
        formatStatusText(status) {
            const statusMap = {
                'IN_PROGRESS': 'In Progress',
                'NOT_STARTED': 'Not Started',
                'COMPLETED': 'Completed',
                'FAILED': 'Failed'
            };
            return statusMap[status] || status;
        },
        async generateDashboard() {
            this.graphLoading = true;
            this.tempObjLWT= [];
            this.tempObjT= [];
            this.tempObjY= []; 

            let countsData;
            try {
            countsData = await this.hourlyCountsWithOutCC(null, [
                this.lastweek_thisday,
                this.previousDay,
                this.thisDay,
            ]);
            } catch(error) {
                this.graphLoading = false;
                if (error.response && error.response.data.error)
                    this.errMsg = error.response.data.error;
                else this.errMsg = error.message;
                return;
            }
            
            this.graphLoading = false;            
            if (!countsData || Object.keys(countsData).length === 0) {
                this.errMsg = "No Data Found";
            } else {
                for (var hr in countsData) {                    
                    if (this.$store.state.environment !== "test" || hr.length > 8) {
                        switch (hr.substring(0, 8)) {
                        case this.lastweek_thisday:
                            this.tempObjLWT.push({hour:hr.substr(-2), count: countsData[hr].count });
                            break;
                        case this.thisDay:
                            this.tempObjT.push({hour:hr.substr(-2), count: countsData[hr].count });
                            break;
                        case this.previousDay:
                            this.tempObjY.push({hour:hr.substr(-2), count: countsData[hr].count });
                            break;
                        default:      
                            this.tempObjY.push({hour:hr.substr(-2), count: countsData[hr].count }); 
                            break;
                        }
                    }                    
                } 
                await this.$nextTick();
                this.startDrawHourlyGraph('countChart',this.tempObjT, this.tempObjY, this.tempObjLWT );
            }
                 
        },
        startDrawHourlyGraph(elementId, thisDayData, previousDayData, prevWeekThisDayData ) {
            if(!thisDayData || !previousDayData ||  !prevWeekThisDayData)
                return;

            const countChart = document.getElementById(elementId);
            const chart = Chart.getChart(elementId);            
            let currentDayData = JSON.parse(JSON.stringify(thisDayData));

            if(chart) {
                chart.destroy();
            }

            //remove most recent hour to not skew the graph 
            if(!this.showCurrentHour) {
                currentDayData.pop();
            } 
            
            const currentDayDataSetLength = currentDayData.length?currentDayData.length:0;
     

            const labels = ["00","01","02","03","04","05","06", "07", "08", "09", "10", "11","12", "13", "14", "15", "16", "17", "18", "19", "20", "21", "22", "23"];
            const gData = {
                labels: labels,
                datasets: [{
                    label: 'Previous Week This Day',
                    backgroundColor: 'rgb(255, 99, 132)', 
                    borderColor: 'rgb(255, 99, 132)',
                    data: prevWeekThisDayData? prevWeekThisDayData.map((obj) => { 
                        return {'x':obj.hour, 'y':obj.count}
                    }) : 0,
                    pointStyle: 'circle',
                    pointRadius: 3
                },{
                    label: 'Previous Day',
                    backgroundColor: 'rgb(12, 196, 2)',
                    borderColor: 'rgb(12, 196, 2)',
                    data: previousDayData? previousDayData.map((obj) => { 
                        return {'x':obj.hour, 'y':obj.count}
                    }): 0,
                    pointStyle: 'circle',
                    pointRadius: 3
                },{
                    label: 'This Day',
                    backgroundColor: 'rgb(1, 94, 255)',
                    borderColor: 'rgb(1, 94, 255)',
                    data: currentDayData? currentDayData.map((obj) => { 
                        return {'x':obj.hour, 'y':obj.count}
                    }): 0,
                    pointStyle: 'circle',
                    segment: { 
                        borderDash: ctx =>  ((currentDayDataSetLength - 1 === ctx.p1DataIndex) && this.showCurrentHour)?[3,3]: []  
                    },
                    animations: {
                        radius: {
                            duration: 1000,
                            easing: 'linear',                            
                            to: 3,
                            loop: true
                        }
                    }
                }                   

                ]
            };

            const options= {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: 'bottom',
                    },
                    title: {
                        display: false,
                        text: 'Hourly Chart'
                    },
                    tooltip: {
                        usePointStyle: true,
                    }
                },
                elements: {
                    point: {
                        radius: (ctx) => (((ctx.chart.data.datasets[ctx.datasetIndex].data.length - 1 === ctx.index)&& this.showCurrentHour) ? 6 : 3)
                    },                    
                },       
            }

            const config = {
                type: 'line',
                data: gData,
                options: options
            }

            if (countChart) {
                new Chart(countChart, config);
            }            

        },

        async hourlyCountsWithOutCC(cls, dates) {
            try {
                let timeRanges = generateHourAndRawMetricsTimeRanges(dates);
                console.log("timeRanges: ", timeRanges);
                if (timeRanges.length === 0) {
                    return {};
                }
                let fetchAllDataForRange = async (range) => {
                    if (!range.start_time || !range.end_time || !range.metrics_name) {
                        return [];
                    }
                    let countsPayload = {
                        start_time: range.start_time,
                        end_time: range.end_time,
                        aggregate: true,
                        filter_dimensions: {
                        beacon_id: "NA",
                        partner_domain: "NA",
                            cid: this.cid,
                        },
                        metrics: {
                            [range.metrics_name]: {
                                version: "1.0.0",
                                header: ["time", "count"],
                            },
                        },
                    };
                    if (cls) {
                        countsPayload.filter_dimensions.class = cls;
                    }
                    return getCountsData(
                            this.$store.state.countsUrl,
                            this.cid,
                            this.$store.state.accessToken,
                            countsPayload
                        );
                };
                let requests = timeRanges.map((range) => fetchAllDataForRange(range));
                let responses = await Promise.all(requests);
                let result = {};
                responses.flat().forEach(([dateHour, cnt]) => {
                    let formattedDateHour = dayjs(dateHour).format("YYYYMMDD_HH");
                    if (!result[formattedDateHour]) {
                        result[formattedDateHour] = {count : 0};
                    }
                    result[formattedDateHour].count += cnt;
                });
                return sortKeysRecursively(result);
            } catch (error) {
                console.error("Error processing hourlyCountsWithOutCC:", error);
                throw error;
            }
        },
        async getBlogList() {
            this.blogLoading=true;
            this.$store.dispatch("getBlogData").then(response=>{
                this.blogLoading = false;   
                this.blogList=response;
            }).catch((e) => {
                this.blogLoading = false; 
                this.blogList = [];
            })
        },
        async fetchMarketplaceProducts() {
            if (!this.isMarketplaceClient || !this.marketplaceAccountId) {
                return;
            }
            
            this.marketplaceProductsLoading = true;
            this.marketplaceProductsError = null;
            
            try {
                const products = await this.$store.dispatch('fetchMarketplaceProducts', this.marketplaceAccountId);
                this.marketplaceProducts = products;
            } catch (error) {
                this.marketplaceProductsError = error.message;
                console.error('Error fetching marketplace products:', error);
            } finally {
                this.marketplaceProductsLoading = false;
            }
        },
        onRefresh(){
            this.refreshOnboardStatus();
            this.getRegisteredSKUs();
        },
        async refreshOnboardStatus() {
            try {
                const res = await this.$store.dispatch('fetchOnboardStatus', this.cid).then((res)=>{
                    this.onBoardStatusList = res;
                })
            } catch (error) {
                console.error('Error refreshing onboard status:', error);
            }
        },
         async getRegisteredSKUs() {
            try {
                const res = await this.$store.dispatch('fetchRegisteredSKUs', this.cid).then((res)=>{
                    this.skuList = res;
                })
            } catch (error) {
                console.error('Error getting registered skus:', error);
            }
        },

        async fetchCheckListStatus() {
            try {
                this.checkListStatus = await this.$store.dispatch('admin/fetchCheckListStatus');
            } catch (error) {
                console.error('Error fetching checklist status:', error);
                this.checkListStatus = null;
            }
        },

        navigateToCheckList() {
            this.$router.push("/check-list");
        },
        loadRecentPages() {
            try {
                this.recentPages = JSON.parse(localStorage.getItem('recentPages') || '[]');
            } catch (e) {
                this.recentPages = [];
            }
        },
        formatTimeAgo(timestamp) {
            const seconds = Math.floor((Date.now() - timestamp) / 1000);
            if (seconds < 60) return 'Just now';
            const minutes = Math.floor(seconds / 60);
            if (minutes < 60) return `${minutes}m ago`;
            const hours = Math.floor(minutes / 60);
            if (hours < 24) return `${hours}h ago`;
            const days = Math.floor(hours / 24);
            return `${days}d ago`;
        }
    },
    mounted() {
        this.loadRecentPages();
        // Nothing below can run without a selected client; skip it so we don't fire
        // requests with a null cid (and show the no-clients empty state instead).
        if (!this.$store.state.currentClient) {
            return;
        }
        this.$store.dispatch('aut/fetchAutClientData', this.cid)
        this.generateDashboard();
        this.getBlogList();
        this.onRefresh();
        this.fetchCheckListStatus();
        // Fetch marketplace products if this is a marketplace client
        if (this.isMarketplaceClient) {
            this.fetchMarketplaceProducts();
        }
    },
};
</script>

<style scoped>
.steps-indicator {
    z-index: 10;
}

.steps-badge {
    font-size: 0.75rem;
    padding: 0.25rem 0.5rem;
}


.recent-page-link:hover {
    background-color: #f0f5fa;
    color: #1a5bb5;
}

/* Empty state shown when the user has no clients */
.no-clients {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 80vh;
    padding: 2rem 1rem;
}

.no-clients__card {
    width: 100%;
    max-width: 30rem;
    text-align: center;
}

.no-clients__logo {
    width: 170px;
    max-width: 60%;
    height: auto;
    margin-bottom: 2rem;
}

.no-clients__title {
    font-size: 1.75rem;
    font-weight: 600;
    letter-spacing: -0.01em;
    margin-bottom: 0.75rem;
}

.no-clients__lead {
    font-size: 1.0625rem;
    margin-bottom: 0.5rem;
}

.no-clients__text {
    font-size: 0.9375rem;
    color: #6e84a3;
    line-height: 1.6;
    margin-bottom: 1.75rem;
}

.no-clients__text a {
    color: #2c7be5;
    font-weight: 500;
    text-decoration: none;
}

.no-clients__text a:hover {
    text-decoration: underline;
}

.no-clients__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    justify-content: center;
    margin-bottom: 1.5rem;
}

.no-clients__logout {
    display: inline-block;
    font-size: 0.875rem;
    color: #6e84a3;
    text-decoration: none;
}

.no-clients__logout:hover {
    color: #2c7be5;
}
</style>